import { useState } from "react";
import { post } from "../networking/RequestService";

function useUploadDealAttachments({ onSuccess, onError } = {}) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const uploadFiles = async (fn, params = {}) => {
        setLoading(true);
        setError(null);

        const { files } = params;

        if (!files || files.length === 0) {
            const errorMessage = "Missing required parameters";
            setError(errorMessage);
            if (typeof onError === "function") {
                onError(errorMessage);
            }
            setLoading(false);
            return { error: errorMessage };
        }

        try {
            const response = await post({ fn, files, ...params });
            if (typeof onSuccess === "function") {
                onSuccess(response.data);
            }
            return { data: response.data };
        } catch (error) {
            const errorMessage = error?.response?.data?.text || error?.message || "An unexpected error occurred";
            setError(errorMessage);
            if (typeof onError === "function") {
                onError(errorMessage);
            }
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    const uploadDealAttachments = (params = {}) => uploadFiles("uploadDealAttachments", params);
    const uploadDealCv = (params = {}) => uploadFiles("uploadDealCv", params);

    return { uploadDealAttachments, uploadDealCv, loading, error };
}

export default useUploadDealAttachments;
